const formatNumber = (number) => {
  if (isNaN(number)) return "-";
  return new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);
};

export default formatNumber;
